import React from 'react';

import { ReactComponent as SubwayIcon } from 'assets/icons/ic_subway.svg';
import { ReactComponent as TownIcon } from 'assets/icons/ic_town.svg';
import { ReactComponent as UnivIcon } from 'assets/icons/ic_univ.svg';
import WhereItem from 'components/search/WhereItem';

import { WhereSearchItem } from '../store/useWhereSearchStore';

export function RecentlySearchResults({
  whereSearches,
  handleClick,
  headerText,
}: {
  whereSearches: WhereSearchItem[];
  handleClick: ({ originalValue, value, type }: { originalValue: string; value: string; type: string }) => void;
  headerText: string;
}) {
  const getIconByType = (type: string) => {
    if (type === 'UNIVERSITY') {
      return UnivIcon;
    }

    if (type === 'ADDRESS') {
      return TownIcon;
    }

    return SubwayIcon;
  };

  return (
    <div className="flex w-full flex-col gap-y-3 px-4 py-5 md:px-10 md:py-[30px]">
      <h3 className="text-[12px] text-[#A9A9A9] md:text-[14px]">{headerText}</h3>

      <div className="flex w-full flex-col">
        <div className="flex w-full flex-col gap-y-1.25">
          <div className="w-full flex-col items-center gap-x-0.5 overflow-x-auto">
            {whereSearches.map((item) => (
              <WhereItem
                key={item.id}
                icon={getIconByType(item.whereType)}
                text={item.originalValue}
                onClick={() =>
                  handleClick({
                    originalValue: item.originalValue,
                    value: item.whereValue,
                    type: item.whereType,
                  })
                }
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
